module.exports = {
  // 艺人
  postFrontArtistHome: '/front/artist/home', //艺人主页
  postFrontArtistMini: '/front/artist/mini', //艺人基础信息
  // postFrontArtistNickname: "/front/artist/nickname", //艺人昵称
  postFrontArtistEndorsementList: '/front/artist/endorsement_list', //代言列表
  postFrontArtistEndorsementYear: '/front/artist/endorsement_year', //代言年份
  postFrontArtistEndorsementItem: '/front/artist/endorsement_item', //代言详细
  postFrontArtistEndorsementNews: '/front/artist/endorsement_news', //代言相关列表
  postFrontArtistEndorsementNewsClass: '/front/artist/endorsement_news_class', //代言相关品类
  postFrontArtistHotList: '/front/artist/hot_list', //热点列表
  postFrontArtistHotClass: '/front/artist/hot_class', //热点分类
  postFrontArtistMovieList: '/front/artist/movie_list', //影视列表
  postFrontArtistMovieClass: '/front/artist/movie_class', //影视分类
  postFrontArtistMovieItem: '/front/artist/movie_item', //影视详细
  postFrontArtistVarietyList: '/front/artist/variety_list', //综艺列表
  postFrontArtistVarietyItem: '/front/artist/variety_item', //综艺详细
  postFrontArtistMusicList: '/front/artist/music_list', //音乐列表
  postFrontArtistMusicClass: '/front/artist/music_class', //音乐分类
  postFrontArtistMusicItem: '/front/artist/music_item', //音乐详细
  postFrontArtistVideo: '/front/artist/video', //视频详细
  postFrontArtistPosterList: '/front/artist/poster_list', //海报列表
  postFrontArtistContentList: '/front/artist/content_list', //图文列表
  postFrontArtistContentItem: '/front/artist/content_item', //图文详细
  postFrontArtistUrlList: '/front/artist/url_list', //链接列表
  // **** 20240927 新增 start ****
  postFrontArtistBusinessClass: '/front/artist/business_class', //商务活动分类
  postFrontArtistBusinessList: '/front/artist/business_list', //商务活动列表
  postFrontArtistBusinessItem: '/front/artist/business_item', //商务活动详细
  postFrontArtistHonorList: '/front/artist/honor_list', //荣誉成就列表
  postFrontArtistHonorItem: '/front/artist/honor_item', //荣誉成就详细
  postFrontArtistHonorClass: '/front/artist/honor_class', //荣誉成就分类
  postFrontArtistCharityList: '/front/artist/charity_list', //社会公益列表
  postFrontArtistCharityItem: '/front/artist/charity_item', //社会公益详细
  // **** 20240927 新增 end ****
  // **** 20241012 新增 start ****
  postFrontArtistAlbumList: '/front/artist/album_list', //图集列表
  postFrontArtistAlbumItem: '/front/artist/album_item', //图集详细
  // **** 20241012 新增 end ****
  // 平台
  getFrontWebHome: '/front/web/home', //平台主页
  getFrontWebArtistType: '/front/web/artist_type', //艺人分类
  postFrontWebArtistList: '/front/web/artist_list', //艺人列表
  postFrontWebCelebrityList: '/front/web/celebrity_list', //明星列表
  getFrontWebArtistTag: '/front/web/artist_tag', //筛选标签列表
  postFrontWebEndorsementList: '/front/web/endorsement_list', //商务代言列表
  getFrontWebHotClass: '/front/web/hot_class', //热点分类
  postFrontWebHotList: '/front/web/hot_list', //热点列表
  getFrontWebRecommendClass: '/front/web/recommend_case', //精选案例
  getFrontWebCaseType: '/front/web/case_type', //案例分类
  postFrontWebCaseList: '/front/web/case_list', //案例列表
  postFrontWebCaseItem: '/front/web/case_item', //案例详细
  getFrontWebInformationType: '/front/web/information_type', //资讯分类
  postFrontWebInformationList: '/front/web/information_list', //资讯列表
  postFrontWebInformationItem: '/front/web/information_item', //资讯详细
  postFrontWebActivityList: '/front/web/activities', //明星福利活动
  // 搜索
  postFrontWebSearchCount: '/front/web/search_count', //搜索统计
  postFrontWebSearch: '/front/web/search', //全部搜索
  postFrontWebSearchList: '/front/web/search_list', //分类搜索
  // 商务
  postFrontUserGetBusinessAuth: '/front/user/get_business_auth', //获取商务（编辑）
  postFrontUserGetBusiness: '/front/user/get_business', //获取商务（访客）
  postFrontUserBindBusiness: '/front/user/bind_business', //绑定商务(访客)
  postFrontUserUnbindBusiness: '/front/user/unbind_business', //解绑商务
  // 东娱
  getFrontEndorsementRoundupsWeeklyHome: '/front/endorsement_roundups/weekly_home', //东娱一周星闻
  getFrontDongyuhome: '/front/dongyu_t/home', //东娱主页
  getFrontDongyuMini: '/front/dongyu_t/mini', //东娱-基础信息
  postFrontDongyuArtist: '/front/dongyu_t/artist', //东娱-艺人列表
  postFrontDongyuNewsType: '/front/dongyu_t/news_type', //东娱-资讯分类
  postFrontDongyuNewsList: '/front/dongyu_t/news_list', //东娱-资讯列表
  postFrontDongyuCasesList: '/front/dongyu_t/cases_list', //东娱-案例列表
  postFrontDongyuMusicList: '/front/dongyu_t/music_list', //东娱-演唱会列表
  postFrontDongyuVarietyList: '/front/dongyu_t/variety_list', //东娱-剧综列表
  postFrontDongyuArtistTag: '/front/dongyu_t/artist_tag', //东娱-筛选标签列表
  postFrontDongyuArtistList: '/front/dongyu_t/artist_list', //东娱-艺人列表
  postFrontDongyuArtistType: '/front/dongyu_t/artist_type', //东娱-艺人分类
  postFrontDongyuContentList: '/front/dongyu_t/content_list', //东娱-最新案例列表
  postFrontDongyuContentItem: '/front/dongyu_t/content_item', //东娱-最新案例详情
  getFrontDongyuCasesType: '/front/dongyu_t/cases_type', //东娱-案例分类
  postFrontDongyuArtistExclusive: '/front/dongyu_t/artist_exclusive', //东娱-独家艺人列表
  postFrontDongyuSpectacleList: '/front/dongyu_t/spectacle_list', //东娱-演出列表
  postFrontDongyuSpectacleItem: '/front/dongyu_t/spectacle_item', //东娱-演出详情
  postFrontDongyuEntertainmentList: '/front/dongyu_t/entertainment_list', //东娱-剧综列表
  postFrontDongyuEntertainmentItem: '/front/dongyu_t/entertainment_item', //东娱-剧综详情
  // 其他
  getWxJssdk: '/wx/jssdk', //获取微信JS-SDK参数
  postWxGenerateUrlLink: '/wx/generateUrlLink', //获取加密URLLink
  postWxGetUnlimitedQRCode: '/wx/getUnlimitedQRCode', //获取不限制的小程序码
  postWxGenerateShortLink: '/wx/generateShortLink', //获取ShortLink（有数量限制）
  getFrontShortcodeGenerate: '/front/shortcode/generate', //获取短码
  // 第三方授权
  postWxToken: '/wx/token', //微信网页授权
  postWxWbLogin: '/wx/web_login', //微信扫码登录、网页版扫码登录
  postWxBindTel: '/wx/bind_tel', //微信绑定手机号
  // 用户&登录
  postFrontUserSmsCode: '/front/user/sms_code', //发送验证码
  postFrontUserRefreshToken: '/front/user/refresh_token', //刷新访问令牌
  postFrontUserLogin: '/front/user/login', //手机号登录
  postFrontUserBindThird: '/front/user/bind_third', //绑定第三方
  postFrontUserUnBindThird: '/front/user/unbind_third', //解绑第三方
  postFrontUserUnBindThird: '/front/user/unbind_third', //解绑第三方
  postFrontUserLoginSilent: '/wx/mini_h5_login', // H5静默登录
  postWxMiniH5RefreshToken: '/wx/mini_h5_refresh_token', // H5刷新 token
  postFrontUserh5Logout: '/wx/mini_h5_logout', // H5退出登录
  postFrontUserMiniTicket: '/wx/mini_ticket', // 已登录换取 ticket（跨站同步登录）
  postFrontDiagnosticsAuthTrace: '/front/diagnostics/auth_trace', // 认证轨迹上报
  // **** 20250102 新增 start ****
  // 艺人交互
  postFrontUserSubscribe: '/front/user/subscribe', //订阅艺人
  postFrontUserUnSubscribe: '/front/user/unsubscribe', //取消订阅艺人
  postFrontUserLike: '/front/user/like', //点赞艺人
  postFrontUserUnLike: '/front/user/unlike', //取消点赞艺人
  postFrontUserInteractionStatus: '/front/user/interaction_status', //获取交互状态
  postFrontUserShare: '/front/user/share', //分享艺人
  // postFrontUserSubscribeStatus: "/front/user/subscribe_status",//获取订阅状态
  // 个人中心
  getFrontUserInfo: '/front/user/info', //用户信息
  postFrontUserSaveInfo: '/front/user/save_info', //修改用户信息
  postFrontUserUpfileToken: '/front/user/upfile_token', //上传图片
  postFrontUserSaveNickname: '/front/user/save_nickname', //修改昵称
  postFrontUserSaveHeadimgurl: '/front/user/save_headimgurl', //修改头像
  postFrontUserSubscribeList: '/front/user/subscribe_list', //我的订阅
  postFrontUserActivityList: '/front/user/activities', //我的活动
  postFrontUserThirdInfo: '/front/user/third_info', //获取第三方信息
  getFrontUserStarlightActivity: '/front/user/starlight_activity', //星辉活动
  // **** 20250102 新增 end ****
  // **** 20250116 新增 start ****
  // AI合影
  postFrontFacefusionArtistList: '/front/facefusion/artist_list', //ai-艺人列表
  postFrontFacefusionArtist: '/front/facefusion/artist', //ai-艺人主页
  postFrontFacefusionMultipleList: '/front/facefusion/multiple_list', //ai-多人列表
  postFrontFacefusionMultiple: '/front/facefusion/multiple', //ai-多人主页
  postFrontFacefusionTmplList: '/front/facefusion/tmpl_list', //ai-模板列表
  postFrontFacefusionTmplItem: '/front/facefusion/tmpl_item', //ai-模板详细
  postFrontFacefusionRecognition: '/front/facefusion/recognition', //ai-[第一步]人脸识别
  postFrontFacefusionFusion: '/front/facefusion/fusion', //ai-[第二步]人脸融合
  postFrontFacefusionHistory: '/front/facefusion/history', //ai-我的合影
  postFrontFacefusionBlessings: '/front/facefusion/blessings', //ai-祝福语
  postFrontFacefusionHistoryItem: '/front/facefusion/history_item', //ai-我的合影详细
  // 用户-订单系统
  postFrontUserPayCode: '/front/user/pay_code', //订单类型
  postFrontUserCreateOrder: '/front/user/create_order', //创建订单
  postFrontUserOrderStatus: '/front/user/order_status', //查询订单状态
  postFrontPayWeixinH5: '/pay/weixin/h5', //H5支付
  postFrontPayWeixinJsapi: '/pay/weixin/jsapi', //JSAPI支付
  // **** 20250116 新增 end ****
  // **** 20250304 新增 start ****
  // 用户评论
  postFrontCommentList: '/front/comment/list', //主评论列表
  postFrontCommentSubList: '/front/comment/sub_list', //子评论列表
  postFrontCommentSave: '/front/comment/save', //新增评论
  postFrontCommentDel: '/front/comment/del', //删除评论
  postFrontCommentLike: '/front/comment/like', //点赞评论
  postFrontCommentUnLike: '/front/comment/unlike', //取消点赞
  // **** 20250304 新增 end ****
  // 20250428 add start
  postFrontWebEndorsementWeeklyList: '/front/web/endorsement_weekly_list', //一周官宣列表
  postFrontWebEndorsementWeeklyItem: '/front/web/endorsement_weekly_item', //一周官宣详细
  postFrontWebEndorsementMonthlyList: '/front/web/endorsement_monthly_list', //月度盘点列表
  postFrontWebEndorsementMonthlyItem: '/front/web/endorsement_monthly_item', //月度盘点详细
  postFrontWebEndorsementCategories: '/front/web/endorsement_categories', //代言品类
  postFrontWebEndorsementCategoryBrands: '/front/web/endorsement_category_brands', //代言品牌
  postFrontWebEndorsementBrandSearch: '/front/web/endorsement_brand_search', //搜索品牌
  postFrontWebEndorsementBrandItem: '/front/web/endorsement_brand_item', //品牌详细
  // 20250428 add end
  // 20250616 新增榜单
  postFrontWebEndorsementRankingDate: '/front/web/endorsement_ranking_date', //周期列表
  postFrontWebEndorsementRankingList: '/front/web/endorsement_ranking_list', //榜单列表
  postFrontWebEndorsementRankingItem: '/front/web/endorsement_ranking_item', //榜单详细
  // **** 20250620 新增 start ****
  // H5活动
  postFrontActivitySignupAdd: '/front/activity/signup/add', //提交报名信息
  postFrontActivitySignupGet: '/front/activity/signup/get', //获取报名信息
  postFrontActivityAdminGetsignupinfo: '/front/activity/admin/getsignupinfo', //获取报名信息
  postFrontActivityAdminCheckin: '/front/activity/admin/checkin', //签到报名信息
  // 临时报名活动
  postUserInfo: '/front/support_event/user/info', //获取用户信息
  postUserSignUp: '/front/support_event/user/sign_up', //提交报名
  postUserVerifyCode: '/front/support_event/user/verify_code', //获取核销码
  postUserCancelSignUp: '/front/support_event/user/cancel_sign_up', //取消报名
  postAdminVerify: '/front/support_event/admin/verify', //核销报名
  postAdminSignedUpUsers: '/front/support_event/admin/signed_up_users', //报名列表
  postAdminDecode: '/front/support_event/admin/decode', //解析核销码
  // 盛典抽奖兑换门票活动
  postCCeremonyTicketInfo: '/c/ceremony_ticket/user/info', //获取中奖和登记状态
  postCCeremonyTicketChou: '/c/ceremony_ticket/user/chou', //抽奖或兑换
  postCCeremonyTicketIdTypes: '/c/ceremony_ticket/user/id_types', //获取证件类型
  postCCeremonyTicketSignup: '/c/ceremony_ticket/user/signup', //登记实名信息
  // 代言人影响力盛典门票抽奖（主持人大屏）
  getInfluenceLotteryManageAuthConfig: '/c/influence-lottery/manage/auth-config', //查询主持人登录开关
  postInfluenceLotteryManageLogin: '/c/influence-lottery/manage/login', //主持人登录
  getInfluenceLotteryManageStatus: '/c/influence-lottery/manage/status', //查询主持人页面状态
  getInfluenceLotteryManageCandidates: '/c/influence-lottery/manage/candidates', //获取滚动动画候选人
  postInfluenceLotteryManageDraw: '/c/influence-lottery/manage/draw', //主持人开奖
  postInfluenceLotteryManageTestReset: '/c/influence-lottery/manage/test/reset', //重置抽奖测试状态
  // 王楚钦抽奖活动
  getlotteryCommunityScreen: '/c/lottery/api/community/screen', //社区抽奖大屏数据
  postlotteryCommunityDraw: '/c/lottery/api/community/draw', //社区普通奖抽奖
  postlotteryCommunityExtraDraw: '/c/lottery/api/community/extra-draw', //社区额外抽奖
  postlotteryCommunityMyWinners: '/c/lottery/api/community/my-winners', //我的社区中奖结果
  // 星火指数榜
  postFrontWebSparkRankingDate: '/front/web/spark_ranking_date', //星火指数周期
  postFrontWebSparkRankingList: '/front/web/spark_ranking_list', //星火指数列表
  postFrontWebSparkRankingItem: '/front/web/spark_ranking_item', //星火指数详细
  postFrontWebSparkRankingTrend: '/front/web/spark_ranking_trend', //星火指数趋势
  postFrontOssToken: '/front/oss/token', //上传文件
  getPublicMapProxy: '/public/map/proxy', //腾讯位置服务
  // **** 20251009 新增 start ****
  // 站子
  // publicCommunityChannels: "/public/community/channels", //所有站子(get)
  // publicCommunityChannelsMe: '/public/community/channels/me', //我的站子(get)
  // publicCommunitySubscriptions: "/public/community/subscriptions", //我的订阅(get)
  // publicCommunitySubscriptions: '/public/community/channels/{channel_id}/posts', //站子帖子（get）
  // publicCommunityChannels: '/public/community/channels/{channel_id}', //站子信息（get）
  // publicCommunityChannels: '/public/community/channels/{channel_id}/subscriptions', //订阅站子（post）
  // publicCommunityChannels: '/public/community/channels/{channel_id}/subscriptions', //取消订阅（delete）
  // publicCommunityChannels: '/public/community/channels/{channel_id}/posts', //发布帖子（post）
  // 帖子
  publicCommunityPosts: '/public/community/posts', //所有帖子(get)
  // publicCommunityPosts: '/public/community/posts', //发布帖子（post）
  // publicCommunityPosts: '/public/community/posts/{post_id}', //获取帖子（get）
  // publicCommunityPosts: '/public/community/posts/{post_id}', //编辑帖子（put）
  // publicCommunityPosts: '/public/community/posts/{post_id}', //删除帖子（delete）
  // publicCommunityPosts: '/public/community/posts/{post_id}/base', //帖子基础信息（get）
  // publicCommunityPosts: '/public/community/posts/{post_id}/applications', //帖子报名列表（get）
  // publicCommunityPosts: '/public/community/posts/{post_id}/addons', //提交返图（post）
  // publicCommunityPosts: '/public/community/posts/{post_id}/addons', //返图列表（get）
  // publicCommunityPosts: '/public/community/posts/{post_id}/likes', //点赞帖子（post）
  // publicCommunityPosts: '/public/community/posts/{post_id}/likes', //取消点赞帖子（delete）
  publicCommunityCelebrities: '/public/community/celebrities', //明星列表
  // 活动报名
  publicCommunityEvents: '/public/community/events', //报名
  // publicCommunityEvents: "/public/community/events/{event_id}/applications", //用户提交报名（post）
  // publicCommunityEvents: "/public/community/events/{event_id}/stats", //报名统计（get）
  publicCommunityApplications: '/public/community/applications',
  // publicCommunityApplications: "/public/community/applications/{my_id}", //用户取消报名（delete）
  // publicCommunityApplications: "/public/community/applications/{application_id}/reviews", //审核报名（patch）
  // 返图征集
  publicCommunityAddons: '/public/community/addons', //返图
  // publicCommunityAddons: '/public/community/addons/{addon_id}', //获取返图（get）
  // publicCommunityAddons: '/public/community/addons/{addon_id}', //删除返图（delete）
  // publicCommunityAddons: '/public/community/addons/{addon_id}/replies', //评论返图（post）
  // publicCommunityAddons: '/public/community/addons/{addon_id}/replies', //返图的评论列表（get）
  // publicCommunityAddons: '/public/community/addons/{addon_id}/likes', //点赞返图（post）
  // publicCommunityAddons: '/public/community/addons/{addon_id}/likes', //取消点赞返图（delete）
  // 评论
  publicCommunityComments: '/public/community/comments', //评论
  // publicCommunityPosts: '/public/community/posts/{post_id}/comments', //评论帖子（post）
  // publicCommunityPosts: '/public/community/posts/{post_id}/comments', //帖子主评论列表 （get）
  // publicCommunityComments: '/public/community/comments/{comment_id}/replies', //回复评论（post）
  // publicCommunityComments: '/public/community/comments/{comment_id}/replies', //子评论列表（get）
  // publicCommunityComments: '/public/community/comments/{coment_id}', //删除评论（delete）
  // publicCommunityComments: '/public/community/comments/{comment_id}/likes', //点赞评论（post）
  // publicCommunityComments: '/public/community/comments/{comment_id}/likes', //取消点赞评论（delete）
  publicCommunityFollowingUsers: '/public/community/following/users', //我订阅的用户（get）
  // publicCommunityFollowingUsers: "/public/community/following/users", //订阅用户（post）
  // publicCommunityFollowingUsers: "/public/community/following/users/{target_user_id}", //取消订阅（delete）
  publicCommunityFollowingUsersPosts: '/public/community/following/users/posts', //我订阅的用户帖子流（get）
  // publicCommunityFollowingCelebrities: '/public/community/following/celebrities', //我加入的圈子（post）
  // publicCommunityFollowingCelebritiesPosts: '/public/community/following/celebrities/posts', //我加入的圈子帖子流（get）
  // publicCommunityCelebrities:"/public/community/celebrities/{celebritiy_id}/posts", //圈子帖子列表（get）
  publicCommunityUsers: '/public/community/users', //用户主页（get）
  // publicCommunityUsers: "/public/community/users/{user_id}", //用户主页（get）
  // publicCommunityUsers: "/public/community/users/{user_id}/posts", //用户帖子列表（get）
  publicCommunityMePostPreferences: '/public/community/me/post-preferences', //帖子偏好
  publicCommunityUsersRecommendations: '/public/community/users/recommendations', //推荐用户列表
}
